export default class AccessibilityFontSite {
    constructor() {
        this.storageKey = 'font-size-preference';

        this.fontSize = {};
        this.getFontSizePreference();
        this.setPreference();
        this.btnChangeFontSize = document.querySelectorAll('.btnFontSizeAction');

        this.ready();
    }

    ready() {
        if (this.btnChangeFontSize) {
            this.btnChangeFontSize.forEach((el) => {
                el.addEventListener('click', () => {
                    if (el.dataset.size == 'more' && this.fontSize.value < 20) {
                        this.fontSize.value = +this.fontSize.value + 2;
                    }
                    if (el.dataset.size == 'less' && this.fontSize.value > 16) {
                        this.fontSize.value = +this.fontSize.value - 2;
                    }
                    this.setPreference();
                });
            });
        }
    }

    changeFontSize() {
        document.querySelector('html').style.fontSize = this.fontSize.value + 'px';
    }

    setPreference() {
        localStorage.setItem(this.storageKey, this.fontSize.value);
        this.changeFontSize();
    }

    getFontSizePreference() {
        if (localStorage.getItem(this.storageKey) && localStorage.getItem(this.storageKey) != 'undefined') {
            this.fontSize.value = localStorage.getItem(this.storageKey);
        } else {
            this.fontSize.value = '16';
        }
    }
}

new AccessibilityFontSite();
